export { default } from "./Seats";
